module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_4_m.4b033a983704dc9ea34061c8bcff9778.png";